import React from "react";

export default function Titleofsection({ title, spantitle, descreption }) {
  return (
    <div className="title-section">
      <div className="container">
        <div className="title">
          <h1>
            {title} <span> {spantitle}</span>
          </h1>
        </div>
        <p className="descreption">{descreption}</p>
      </div>
    </div>
  );
}
